import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { Router } from '@angular/router';

export interface DialogData {
  any
}

@Component({
  selector: 'app-contract-detail-note-dialog',
  templateUrl: './contract-detail-note-dialog.component.html',
  styleUrls: ['./contract-detail-note-dialog.component.less']
})
export class ContractDetailNoteDialogComponent implements OnInit {

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  // 物件名
  siteName = '';

  // 備考
  note = '';

  // クリーンプラス
  cleanPlus: number = null;

  // ランク
  rank: String = null;
  // ランクリスト
  rankList = [
    { key: 'A', value: 'A' },
    { key: 'B', value: 'B' },
    { key: 'C', value: 'C' },
    { key: 'D', value: 'D' },
  ]

  // 備考orクリーンプラスorランク
  type = '';
  title: String = null;

  // 保存内容
  contractDetailNote = {
    note: '',
    cleanPlus: null,
    rank: null,
    contractDetailNoteId: {}
  }

  constructor(private router: Router, private http: HttpClient, @Inject(MAT_DIALOG_DATA) private data: DialogData, private dialogRef: MatDialogRef<ContractDetailNoteDialogComponent>, private ngZone: NgZone) { }

  ngOnInit() {
    if (this.data['nameSite']) {
      this.siteName = this.data['nameSite'];
    };

    this.type = this.data['type']
    if (this.data['type'] == 'note' && this.data['note']) {
      this.note = this.data['note'];
    };
    if (this.data['type'] == 'cleanPlus' && this.data['cleanPlus']) {
      this.cleanPlus = this.data['cleanPlus'];
    };
    if (this.data['type'] == 'rank' && this.data['rank']) {
      this.rank = this.data['rank'];
    };

    const t = { note: '備考', cleanPlus: 'クリーンプラス金額', rank: 'ランク' }
    this.title = t[this.type]
  }

  goTo(comp, param){
    this.ngZone.run(()=>{
    this.router.navigate([comp, param])
    });
  }

  /**
   * 保存ボタンイベント
   */
  save() {
    let contractDetailNoteId = {
      cdSite: this.data['cdSite'],
      cdContract: this.data['cdContract']
    }
    this.contractDetailNote = {
      contractDetailNoteId,
      note: this.note,
      cleanPlus: this.cleanPlus,
      // 「ランクを選択してください」は select の値が文字列 "null" で来るので、未設定（NULL）として送る
      rank: this.rank === 'null' || this.rank === '' ? null : this.rank
    };

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    this.http.post(
      API_BASE_URL + '/api/v1/contractDetail/note?siteName=' + this.siteName
      + '&type=' + this.data['type']
      + '&title=' + this.title,
      this.contractDetailNote, httpOptions
    ).subscribe(res => {
      this.dialogRef.close();
    },error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
      this.dialogRef.close();
    });
  }

  /**
   * 閉じるボタンイベント
   */
  close() {
    this.dialogRef.close();
  }

}
